import { styled, Typography } from "@mui/material";
import { useColors } from "../../../Context/ColorsContext";

export const TitleModal = styled('span')(() => {
  const { colors } = useColors();
  return {
    color: colors.sidebarSelectColor,
    fontWeight: 'bold',
    fontSize: 16,
    textTransform: 'uppercase',
  }
})

export const HeaderContainer = styled('div')(() => {
  return {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 20px',
  }
})

export const BodyContainer = styled('div')(() => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '2rem',
  }
})

export const InformationText = styled('span')(({theme}) => {
  const { colors } = useColors();
  return {
    color: colors.buttonActionColor, 
    textAlign: "center", 
    fontWeight: 500,
    marginTop: 8,
    marginBottom: 1,
    width: '60%',
    fontSize: '14px',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
    }
  }
})